import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Projects from './components/Projects/Projects';
import Testimonials from './components/Testimonials/Testimonials';
import ProjectDetail from './components/ProjectDetail/ProjectDetail';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <section id="home">
                  <Hero />
                </section>
                <section id="projects">
                  <Projects />
                </section>
                <section id="testimonials">
                  <Testimonials />
                </section>
                {/* <section id="contact">
                  <SocialLinks />
                </section> */}
              </motion.div>
            </>
          } />
          <Route path="/project/:id" element={<ProjectDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
